<template>
  <div class="absolute top-0 z-50  w-full h-full flex items-center justify-center">
    
    <div class=" w-full h-full bg-gray-500 blur-lg opacity-70"></div>

    <div class=" orderPanel  absolute flex flex-col m-auto w-10/12 md:w-4/5 md:max-w-md rounded bg-slate-200">
      <div>
        <div class="flex border-b border-blue-400 p-2 ">
          <div class="ml-auto font-bold text-xl">All Users {{ data.length }}</div>
          <div v-on:click="close()" class=" ml-auto w-8 h-8 bg-slate-100 border-slate-300 rounded-full flex active:scale-75 hover:scale-105">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class=" w-7 h-7 m-auto">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
        </div>
        <div class="flex pl-2">
          <button v-on:click="changeTab('allUsers')" class=" p-2 bg-white text-gray-600 font-medium cursor-pointer shadow px-2 py-1 rounded-b-md border-x-white border-b-white border-x border-b" >Users List</button>
          <button v-on:click="changeTab('owingUsers')" class=" ml-3 p-2 bg-white text-gray-600 font-medium cursor-pointer shadow px-2 py-1 rounded-b-md border-x-white border-b-white border-x border-b" >Owing Users</button>
        </div>

        <div v-if="showOwingUsers" class=" flex text-lg font-semibold mt-2">
          <div class=" m-auto">Users: {{ owingusers.length }}</div>
          <div class=" m-auto">Total Balance: K{{ totalBalanceOwing }}</div>
        </div> 
      </div>
           
      
      <div v-if="showAllUsersList" class=" flex flex-col overflow-y-auto mt-2 w-full text-sm">
        <div v-for="(data,i) in data" :key="i" class=" w-full p-4">
          <div class="flex flex-col w-full h-full rounded bg-gray-100 p-4">
            
          <div class="mt-2 flex flex-row">
            <div class=" ">User Name: {{ data.username }}</div>
            <div v-if="data.is_admin" class=" font-medium ml-auto">Admin</div>            
          </div>

          <div class="mt-2 flex flex-row">
            <div class=" ">First Name: {{ data.first_name }}</div>                   
          </div>

          <div class="mt-2 flex flex-row">
            <div class=" ">Last Name: {{ data.last_name }}</div>                   
          </div>

          <div class="mt-2 flex flex-row">
            <div class=" ">Community: {{ data.community.community_name }}</div>                   
          </div>

          <div class="mt-2 flex flex-row">
            <div class=" ">Email: {{ data.email }}</div>                   
          </div>

          <div class="mt-2 flex flex-row">
            <div class=" ">Phone Number: {{ data.phone_number }}</div>                   
          </div>

          <div class="mt-2 flex flex-row">
            <div class=" ">Balance: {{ data.balance }}</div>                   
          </div>

          <div class="mt-2 flex flex-row">
            <button v-on:click="editUserBalanceButton(data)" class="  bg-white mt-3  text-gray-600 font-medium cursor-pointer shadow px-2 py-1 ml-auto"> Update Balance </button>                 
            <button v-on:click="showUserEntriesButton(data)" class="  bg-white mt-3  text-gray-600 font-medium cursor-pointer shadow px-2 py-1 ml-auto"> Entries </button>                 
            <button v-on:click="editUserCommunityButton(data)" class="  bg-white mt-3  text-gray-600 font-medium cursor-pointer shadow px-2 py-1 ml-auto"> Change Community </button>                 
          </div>


            
        </div>         
          
        </div>

      </div>
    
      <div v-else-if="showOwingUsers" class=" flex flex-col overflow-y-auto mt-2 w-full text-sm">
        <div v-for="(data,i) in owingusers" :key="i" class=" w-full p-4">
          <div class="flex flex-col w-full h-full rounded bg-gray-100 p-4">
            
          <div class="mt-2 flex flex-row">
            <div class=" ">User Name: {{ data.username }}</div>
            <div v-if="data.is_admin" class=" font-medium ml-auto">Admin</div>            
          </div>

          <div class="mt-2 flex flex-row">
            <div class=" ">Phone Number: {{ data.phone_number }}</div>                   
          </div>

          <div class="mt-2 flex flex-row">
            <div class=" font-bold text-base">Balance: K{{ data.balance }}</div>                   
          </div>

          <div class="mt-2 flex flex-row">
            <button v-on:click="editUserBalanceButton(data)" class="  bg-white mt-3  text-gray-600 font-medium cursor-pointer shadow px-2 py-1 ml-auto"> Update Balance </button>                 
            <button v-on:click="showUserEntriesButton(data)" class="  bg-white mt-3  text-gray-600 font-medium cursor-pointer shadow px-2 py-1 ml-auto"> Entries </button>                 
          </div>


            
        </div>         
          
        </div>

      </div>
    
    </div>

  

    <div v-if="previewCase" class=" absolute top-0 z-50  w-full h-full flex items-center justify-center">
    
    <div class=" w-full h-full bg-gray-500 blur-lg opacity-70"></div>
    <div class=" absolute flex flex-col m-auto text-xl font-bold w-10/12 md:w-96 rounded bg-white p-6">
      
      
      <img v-if="ImageData" alt="logo" class="" :src=ImageData>

        <button
                class=" mt-4 self-center bg-gray-200 border-gray-300 border font-medium text-gray-600 cursor-pointer shadow py-2 px-4 mx-auto"
                @click="showPreview(false)"
              >
                Close
        </button>
        <!-- <button
                class=" mt-4 self-center bg-gray-200 border-gray-300 border font-medium text-gray-600 cursor-pointer shadow py-2 px-4 mx-auto"
                @click="ShowPayerMsgBox(false)"
              >
                Save Image
        </button> -->

      </div>
      
    </div>

    <setOrderStatus v-if="showSetOrderStatus"></setOrderStatus>

    <editUserCommunity v-if="showEditUserCommunity"></editUserCommunity>

    <editUserBalance v-if="showEditUserBalance"></editUserBalance>

    <userBalanceEntries v-if="showUserBalanceEntries"></userBalanceEntries>
  
  </div>
  
</template>

<script>
// @ is an alias to /src

import axios from "axios";
import { mapGetters, mapMutations,mapActions } from "vuex";
import SetOrderStatus from "@/views/admin/SetOrderStatusView.vue";
import EditUserCommunity from "@/views/admin/ChangeUserCommunity.vue";
import EditUserBalance from "@/views/admin/ChangeUserBalance.vue";
import UserBalanceEntries from "@/views/CommunityInternet/MyBalanceEntriesView.vue";


export default {
  name: 'UsersPage',
  components: {
    setOrderStatus: SetOrderStatus,
    editUserCommunity: EditUserCommunity,
    editUserBalance: EditUserBalance,
    userBalanceEntries: UserBalanceEntries,
  },
  data () {
       return{
        showAllUsersList:true,
        showOwingUsers:false,
        details:'',
        amount:'',
        status:'',
        order_date:'',
        data:[],
        owingusers:[],
        totalBalanceOwing:0,
        selectedUser:[],
        selectedEntriesUser:null,
        pageNumber: 1,
        PageSize: 100,
        previewCase: false,
        ImageData:null,
        selectedOrder:null,
        selectedOrderIndex:null,
        showSetOrderStatus: false,
        showEditUserCommunity: false,
        showEditUserBalance: false,
        showUserBalanceEntries: false,
        BackendUrl: "https://labsapi.packymstechnology.com"
       }
      },

      computed: {
      ...mapGetters(["GET_SCREENSHOT"]),

    },
  methods:{
    ...mapMutations([
        "REGENERATE_GEOMETRY", 
        "LOADED_STL",
        "SET_COLOR",
        "SET_SCREENSHOT_POSITION"      
      ]),
      ...mapActions(["REGENERATE_GEOMETRY","LOAD_STL","TAKE_SCREENSHOT"]),
    
    updateAndClose(valueData){
      this.data[this.selectedOrderIndex].order_status = valueData;
      this.showUpdateOrderStatus(false);
    },    
    close(){
      this.$parent.showAllUsers(false);
    },
    showPreview(show,img){
      if(show){
      //   this.SET_SCREENSHOT_POSITION()
      // this.$parent.showLoading(true)
      // this.TAKE_SCREENSHOT().then(() => {
      //       setTimeout(()=>{
      //         // this.LOADED_STL()
      //         this.ImageData = this.GET_SCREENSHOT
      //         this.previewCase = true
      //         this.$parent.showLoading(false)
      //       },1000)
      //     })
        this.previewCase = true
        this.ImageData = img
      }else{
        this.previewCase = false
      }
      
    },
    showPayment(amount, ref){
      this.$parent.showPayment(true, amount, ref);
    },
    async loadUsers(){
      this.$parent.showLoading(true)
      let dev = process.env.VUE_APP_DEVELOPMENT;    
    if (dev == "true") {
      console.log("is in dev mode")
      this.BackendUrl = "";
    }
         
      try {
        let result = await axios.get(this.BackendUrl + "/admin/all_users", {
            headers:{
            Authorization : `Bearer ${JSON.parse(localStorage.getItem('account')).access_token}`
          }
          });
          if(result.status == 200){
            // alert(" Order fetched")
            this.data = result.data
            this.loadOwing();
            // this.close();
  
          } else {
            alert("there was an error with placing Order")
          }
      } catch (error) {
        const code = error.response.status
        
          if(code == 401){
            this.close();
            this.$parent.setMessageBox("Please LogIn Again", "warning")
            this.$parent.showLogin(true);
          } else{
            this.$parent.setMessageBox("Something went wrong, Please check your internet connection or try again later", "error")
          }
      }
     
  
          
          this.$parent.showLoading(false)
    },

    GetColorFromDetails(details){
      let options = details.split(",");
      let color = options[1].trim();
      return color
    },

    SetPreview(details, path){
      let dev = process.env.VUE_APP_DEVELOPMENT;  
      if (dev == "true") {
      console.log("is in dev mode")
      this.BackendUrl = "http://localhost:8080";
      path = this.BackendUrl + path.substring(1)
    }
      let color = this.GetColorFromDetails(details)
      this.SET_COLOR(color);
      this.LOAD_STL(path).then(() => {
            setTimeout(()=>{
              // this.LOADED_STL()
              this.$parent.showLoading(false)
              this.close()
            },1000)
          // this.applyChanges();
          });
    },
    showLoading(show){
      this.$parent.showLoading(show)
    },
    showUpdateOrderStatus(show){
      this.showSetOrderStatus = show;
    },

    showEditUserCommunityPanel(show){
      this.showEditUserCommunity = show;
    },

    showEditUserBalancePanel(show){
      this.showEditUserBalance = show;
    },

    showUserEntries(show){
      this.showUserBalanceEntries = show;
    },

    editUserCommunityButton(data){
      this.selectedUser = data;
      this.showEditUserCommunityPanel(true)
    },

    showUserEntriesButton(data){
      this.selectedUser = data;
      this.selectedEntriesUser = data.username;
      this.showUserEntries(true)
    },

    editUserBalanceButton(data){
      this.selectedUser = data;
      this.showEditUserBalancePanel(true)
    },

    ChangeStatus(id, index){
      this.selectedOrder = id;
      this.selectedOrderIndex = index;
      this.showUpdateOrderStatus(true);
    },
    setMessageBox(message,type){
      this.$parent.setMessageBox(message, type)
    },
    changeTab(tab){
      if(tab == "allUsers"){
        this.showAllUsersList = true;
        this.showOwingUsers = false;
      } else if(tab == "owingUsers"){
        this.showAllUsersList = false;
        this.showOwingUsers = true;
      }
    },
    loadOwing(){
      this.owingusers = [];
      this.totalBalanceOwing = 0;
      console.log("loading owing")
      for (let index = 0; index < this.data.length; index++) {
        if(this.data[index].balance > 0){
          this.totalBalanceOwing = this.totalBalanceOwing + this.data[index].balance;
          this.owingusers.push(this.data[index])
        }
               
      }
      console.log(this.owingusers)
    }
  },
  mounted(){
    let user = localStorage.getItem('account');
    if(user) {
      this.loadUsers();
    }
  }
  
}
</script>
<style scoped>
.orderPanel{
max-height: 85%;
}
</style>
